module.exports = __webpack_public_path__ + "static/img/Jack_Martin_mobile.43055d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack_Martin_mobile.jpg
// module id = ttTP
// module chunks = 0